export class AssetRoutes {
  static forAvatar(userId) {
    return `/assets/avatars/${userId}`;
  }

  static forDocumentUpload() {
    return '/assets/documents';
  }

  static forAddDocumentLink() {
    return '/assets/links';
  }

  static forDocumentLinkNavigate(documentId) {
    return `/assets/links/${documentId}`;
  }

  static forDocumentDownload(documentId) {
    return `/assets/documents/${documentId}`;
  }

  static forExportPdf(url) {
    return `/assets/export/pdf?url=${encodeURIComponent(url)}`;
  }

  static forExportScreenshot(url) {
    return `/assets/export/screenshot?url=${encodeURIComponent(url)}`;
  }
}

export class WebRoutes {
  static forMyProfile() {
    return '/';
  }

  static forEngage() {
    return '/engage';
  }

  static forTrending() {
    return '/trending';
  }

  static forFeed(nodeId) {
    return `/-/${nodeId}`;
  }

  static forDocuments(nodeId) {
    return `/-/${nodeId}/documents`;
  }

  static forTasks(nodeId) {
    return `/-/${nodeId}/tasks`;
  }

  static forEvents(nodeId) {
    return `/-/${nodeId}/events`;
  }

  static forSubscribers(nodeId) {
    return `/-/${nodeId}/subscribers`;
  }

  static forRisks() {
    return '/risks';
  }

  static forRiskView(viewId) {
    if (viewId === 'detailed') {
      return '/risks';
    }
    return `/risks/${viewId}`;
  }

  static forRisk(riskId) {
    return `/risks/${riskId}`;
  }

  static forRiskAnalysis(riskId) {
    return `/risks/${riskId}`;
  }

  static forRiskTreatments(riskId) {
    return `/risks/${riskId}/treatments`;
  }

  static forRiskLinks(riskId) {
    return `/risks/${riskId}/links`;
  }

  static forTreatments() {
    return '/treatments';
  }

  static forModels() {
    return '/inventory';
  }

  static forTreatment(treatmentId) {
    return `/treatments/${treatmentId}`;
  }

  static forModel(shortCode) {
    return `/inventory/${shortCode}`;
  }

  static forItem(shortCode, itemId) {
    return `/inventory/${shortCode}/${itemId}`;
  }

  static forWatchlist() {
    return "/inventory/watchlist";
  }

  static forWatchlistItem(itemId) {
    return `/inventory/watchlist/${itemId}`;
  }

  static forControls() {
    return '/controls';
  }

  static forControl(controlId) {
    return `/controls/${controlId}`;
  }

  static forControlRequirements(controlId) {
    return `/controls/${controlId}/requirements`;
  }

  static forDomains() {
    return '/domains';
  }

  static forDomain(domainId) {
    return `/domains/${domainId}`;
  }

  static forTargets() {
    return '/deployment-targets';
  }

  static forTarget(targetId) {
    return `/deployment-targets/${targetId}`;
  }

  static forActivities() {
    return '/activities';
  }

  static forActivity(activityId) {
    return `/activities/${activityId}`;
  }

  static forAudits() {
    return '/audits';
  }

  static forAudit(auditId) {
    return `/audits/${auditId}`;
  }

  static forAuditActivities(auditId) {
    return `/audits/${auditId}/activities`;
  }

  static forReports() {
    return '/reports';
  }

  static forReport(reportId) {
    return `/reports/${reportId}`;
  }

  static forDemand(demandId) {
    return `/demand/${demandId}`;
  }

  static forBoards() {
    return '/demand';
  }

  static forBoard(boardId) {
    return `/demand/${boardId}`;
  }

  static forWorkItems() {
    return '/work-items';
  }

  static forWorkItem(workItemId) {
    return `/work-items/${workItemId}`;
  }

  static forAudits() {
    return '/audits';
  }

  static forAudit(auditId) {
    return `/audits/${auditId}`;
  }

  static forAuditMaturity(auditId) {
    return `/audits/${auditId}/maturity`;
  }

  static forControlActivitiesSummary(controlId) {
    return `/controls/${controlId}/activities`;
  }

  static forControlFindingsSummary(controlId) {
    return `/controls/${controlId}/findings`;
  }
}

export class ApiRoutes {
  static forTenant(tenantId) {
    return `/v1.0/tenants/${tenantId}`;
  }

  static forRoles() {
    return '/v1.0/roles';
  }

  static forRole(roleId) {
    return `/v1.0/roles/${roleId}`;
  }

  static forMaturityLevel(controlId) {
    return `/v1.0/controls/${controlId}/maturity`;
  }

  static forUsers() {
    return '/v1.0/users';
  }

  static forUsersExport() {
    return '/v1.0/users/export';
  }

  static forUserSearch() {
    return '/v1.0/users/search';
  }

  static forUserResolve() {
    return '/v1.0/users/resolve';
  }

  static forUser(userId) {
    return `/v1.0/users/${userId}`;
  }

  static forDisableUser(userId) {
    return `/v1.0/users/${userId}/disable`;
  }

  static forEnableUser(userId) {
    return `/v1.0/users/${userId}/enable`;
  }

  static forUserRoleChange(userId) {
    return `/v1.0/users/${userId}/role`;
  }

  static forOrgUsers() {
    return '/v1.0/org-users';
  }

  static forRisks() {
    return '/v1.0/risks';
  }

  static forRisksSummary() {
    return '/v1.0/risks/summary';
  }

  static forRiskSearch() {
    return '/v1.0/risks/search';
  }

  static forRiskExport() {
    return '/v1.0/risks/export';
  }

  static forRiskHeatmapSummary() {
    return '/v1.0/risks/heatmap-summary';
  }

  static forRiskCalendarEvents() {
    return '/v1.0/risks/calendar-events';
  }

  static forRiskCalendarEventCounts() {
    return '/v1.0/risks/calendar-event-counts';
  }

  static forRisk(riskId) {
    return `/v1.0/risks/${riskId}`;
  }

  static forRiskWatchlist(riskId) {
    return `/v1.0/risks/${riskId}/watchlist`;
  }

  static forRisksWatchlist(riskId) {
    return `/v1.0/risks/watchlist/${riskId}`;
  }

  static forRiskAssign(riskId) {
    return `/v1.0/risks/${riskId}/assign`;
  }

  static forRiskStart(riskId) {
    return `/v1.0/risks/${riskId}/start`;
  }

  static forRiskReview(riskId) {
    return `/v1.0/risks/${riskId}/review`;
  }

  static forRiskSubmit(riskId) {
    return `/v1.0/risks/${riskId}/submit`;
  }

  static forRiskMonitor(riskId) {
    return `/v1.0/risks/${riskId}/monitor`;
  }

  static forRiskClose(riskId) {
    return `/v1.0/risks/${riskId}/close`;
  }

  static forRiskRestore(riskId) {
    return `/v1.0/risks/${riskId}/restore`;
  }

  static forRiskTreatments(riskId) {
    return `/v1.0/risks/${riskId}/treatments`;
  }

  static forRiskLinksByRisk(riskId) {
    return `/v1.0/risks/${riskId}/links`;
  }

  static forRiskLinkSuggest(riskId) {
    return `/v1.0/risks/${riskId}/links/suggest`;
  }

  static forRiskSubscribers(riskId) {
    return `/v1.0/risks/${riskId}/subscribers`;
  }

  static forRiskSubscriber(riskId, userId) {
    return `/v1.0/risks/${riskId}/subscribers/${userId}`;
  }

  static forRiskRoles(entity) {
    return `/v1.0/risk-roles?entity=${entity}`;
  }

  static forRiskFields() {
    return '/v1.0/risk-fields';
  }

  static forRiskTypes() {
    return '/v1.0/risk-types';
  }

  static forRiskType(riskTypeId) {
    return `/v1.0/risk-types/${riskTypeId}`;
  }

  static forRiskScoringGuidance(riskTypeId) {
    return `/v1.0/risk-types/${riskTypeId}/scoring-guidance`;
  }

  static forScoringGuidance(riskTypeId) {
    return riskTypeId
      ? `/v1.0/risk-configuration/scoring-guidance?riskTypeId=${riskTypeId}`
      : '/v1.0/risk-configuration/scoring-guidance';
  }

  static forRiskMatrixConfiguration(riskTypeId) {
    return riskTypeId
      ? `/v1.0/risk-configuration/matrix-configuration?riskTypeId=${riskTypeId}`
      : '/v1.0/risk-configuration/matrix-configuration';
  }

  static forRiskMatrixCellScores() {
    return '/v1.0/risk-configuration/matrix-configuration/cell-scores';
  }

  static forRiskMatrixImpactPreview() {
    return '/v1.0/risk-configuration/matrix-configuration/impact-preview';
  }

  static forResetRiskTypeCustomization(riskTypeId) {
    return `/v1.0/risk-configuration/customization?riskTypeId=${riskTypeId}`;
  }

  static forRiskTypeRoles(riskTypeId) {
    return `/v1.0/risk-types/${riskTypeId}/roles`;
  }

  static forTreatments() {
    return '/v1.0/treatments';
  }

  static forTreatmentExport() {
    return '/v1.0/treatments/export';
  }

  static forTreatmentsSummary() {
    return '/v1.0/treatments/summary';
  }

  static forTreatmentSearch() {
    return '/v1.0/treatments/search';
  }

  static forTreatment(treatmentId) {
    return `/v1.0/treatments/${treatmentId}`;
  }

  static forTreatmentAssign(treatmentId) {
    return `/v1.0/treatments/${treatmentId}/assign`;
  }

  static forTreatmentProgress(treatmentId) {
    return `/v1.0/treatments/${treatmentId}/progress`;
  }

  static forTreatmentComplete(treatmentId) {
    return `/v1.0/treatments/${treatmentId}/complete`;
  }

  // Should Be Checked
  static forTreatmentExpire(treatmentId) {
    return `/v1.0/treatments/${treatmentId}/expire`;
  }

  static forRiskLinks() {
    return '/v1.0/risk-links';
  }

  static forRiskLink(linkId) {
    return `/v1.0/risk-links/${linkId}`;
  }

  static forItems() {
    return '/v1.0/items';
  }

  static forItem(itemId) {
    return `/v1.0/items/${itemId}`;
  }

  // Segments
  static forSegments({ search = "", page = 1 } = {}) {
    const params = new URLSearchParams();
    if (search) params.set("search", search);
    if (page) params.set("page", String(page));
    const qs = params.toString();
    return `/v1.0/segments${qs ? `?${qs}` : ""}`;
  }
  static forSegment(segmentId) {
    return `/v1.0/segments/${segmentId}`;
  }
  static forSegmentFollow(segmentId) {
    return `/v1.0/segments/${segmentId}/follow`;
  }
  static forSegmentSchedulerActivity() {
    return `/v1.0/segments/scheduler-activity`;
  }

  // WatchList
  static forItemSearch() {
    return '/v1.0/items/search';
  }

  static forItemWatchlist(itemId) {
    return `/v1.0/items/${itemId}/watchlist`;
  }

  static forItemsWatchlist(itemId) {
    return `/v1.0/items/watchlist/${itemId}`;
  }

  static forModels() {
    return '/v1.0/models';
  }

  static forModelSearch() {
    return '/v1.0/models/search';
  }
  static forModelExport() {
    return `/v1.0/models/export`;
  }
  static forModel(modelId) {
    return `/v1.0/models/${modelId}`;
  }

  static forModelItems(modelId) {
    return `/v1.0/models/${modelId}/items`;
  }
  static forModelItemsSearch(modelId) {
    return `/v1.0/models/${modelId}/items/search`;
  }
  static forItemDescendants(itemId) {
    return `/v1.0/items/${itemId}/descendants`;
  }
  static forItemAncestors(itemId) {
    return `/v1.0/items/${itemId}/ancestors`;
  }
  static forModelShortCode(shortCode) {
    return `/v1.0/models/by-short-code/${shortCode}`;
  }
  static forModelLabels(modelId) {
    return `/v1.0/models/${modelId}/labels`;
  }
  static forLabel(labelId) {
    return `/v1.0/labels/${labelId}`;
  }
  static forEnsureDefaults() {
    return `/v1.0/models/ensure-defaults`;
  }
  static forModelSubscribers(modelId) {
    return `/v1.0/models/${modelId}/subscribers`;
  }
  static forItemSubscribers(itemId) {
    return `/v1.0/items/${itemId}/subscribers`;
  }
  static forInventoryRoles(entity) {
    return `/v1.0/inventory-roles?entity=${entity}`;
  }

  static forBoards({ search = "", status = "", page = 1 } = {}) {
    const params = new URLSearchParams();
    if (search) params.set("search", search);
    if (status) params.set("status", status);
    if (page) params.set("page", String(page));
    const qs = params.toString();
    return `/v1.0/boards${qs ? `?${qs}` : ""}`;
  }

  static forBoard(boardId) {
    return `/v1.0/boards/${boardId}`;
  }

  static forBoardEnsureDefault() {
    return `/v1.0/boards/ensure-default`;
  }

  static forBoardSubscribers(boardId) {
    return `/v1.0/boards/${boardId}/subscribers`;
  }

  static forDemandRoles(entity) {
    return `/v1.0/demand-roles?entity=${entity}`;
  }

  static forFieldSections() {
    return `/v1.0/field-sections`;
  }
  static forFieldSection(id) {
    return `/v1.0/field-sections/${id}`;
  }
  static forFieldDefinitions() {
    return `/v1.0/field-definitions`;
  }
  static forFieldDefinition(id) {
    return `/v1.0/field-definitions/${id}`;
  }
  static forModelFieldUsages(modelId) {
    return `/v1.0/models/${modelId}/field-definitions`;
  }
  static forModelFieldUsage(modelId, id) {
    return `/v1.0/models/${modelId}/field-definitions/${id}`;
  }
  static forLabelFieldUsages(labelId) {
    return `/v1.0/labels/${labelId}/field-definitions`;
  }
  static forLabelFieldUsage(labelId, id) {
    return `/v1.0/labels/${labelId}/field-definitions/${id}`;
  }

  static forControls() {
    return '/v1.0/controls';
  }

  static forControlsSummary() {
    return '/v1.0/controls/summary';
  }

  static forControlSearch() {
    return '/v1.0/controls/search';
  }

  static forControl(controlId) {
    return `/v1.0/controls/${controlId}`;
  }

  static forControlAssign(controlId) {
    return `/v1.0/controls/${controlId}/assign`;
  }

  static forControlActivate(controlId) {
    return `/v1.0/controls/${controlId}/activate`;
  }

  static forControlDeploy(controlId) {
    return `/v1.0/controls/${controlId}/deploy`;
  }

  static forControlDecommission(controlId) {
    return `/v1.0/controls/${controlId}/decommission`;
  }

  static forControlRequirements(controlId) {
    return `/v1.0/controls/${controlId}/requirements`;
  }

  static forControlWatchlist(controlId) {
    return `/v1.0/controls/${controlId}/watchlist`;
  }

  static forControlsWatchlist(controlId) {
    return `/v1.0/controls/watchlist/${controlId}`;
  }

  static forControlExport() {
    return '/v1.0/controls/export';
  }

  static forControlsMaturityHistory(controlId) {
    return `/v1.0/controls/${controlId}/maturity-history`;
  }

  static forControlsMaturityHistoryItem(controlId, historyItemId) {
    return `/v1.0/controls/${controlId}/maturity-history/${historyItemId}`;
  }

  // Control Activity
  static forControlsActivity(controlId) {
    return `/v1.0/controls/${controlId}/activities/search`;
  }

  static forControlActivitiesSummary(controlId) {
    return `/v1.0/controls/${controlId}/activities/summary/search`;
  }

  static forControlFindingsSearch(controlId) {
    return `/v1.0/controls/${controlId}/findings/search`;
  }

  static forControlFindings(controlId) {
    return `/v1.0/controls/${controlId}/findings`;
  }

  static forRequirements() {
    return '/v1.0/control-requirements';
  }

  static forRequirementSearch() {
    return '/v1.0/control-requirements/search';
  }

  static forRequirement(requirementId) {
    return `/v1.0/control-requirements/${requirementId}`;
  }
  static forRequirementHistory(requirementId) {
    return `/v1.0/control-requirements/${requirementId}/history`;
  }

  static forRequirementDecommission(requirementId) {
    return `/v1.0/control-requirements/${requirementId}/decommission`;
  }
  static forControlSchedulerActivity(controlId) {
    return `/v1.0/controls/${controlId}/scheduler-activity`;
  }
  static forControlRegistry(registryId) {
    return `/v1.0/control-registries/${registryId}`;
  }

  static forControlRegistries() {
    return '/v1.0/control-registries';
  }

  static forImplementationGroups() {
    return '/v1.0/implementation-groups';
  }

  static forImplementationGroup(groupId) {
    return `/v1.0/implementation-groups/${groupId}`;
  }

  static forComplianceRoles(entity) {
    return `/v1.0/compliance-roles?entity=${entity}`;
  }

  static forComplianceFields() {
    return '/v1.0/compliance-fields';
  }

  static forComplianceConfigurations() {
    return '/v1.0/compliance-configuration';
  }

  static forComplianceConfigurationByKey(key) {
    return `/v1.0/compliance-configuration/${key}`;
  }

  static forComplianceConfigurationAudits(key, page) {
    return `/v1.0/compliance-configuration/${key}/audits?page=${page}`;
  }

  static forActivities() {
    return '/v1.0/control-activities';
  }

  static forActivitiesSummary() {
    return '/v1.0/control-activities/summary';
  }

  static forActivitySearch() {
    return '/v1.0/control-activities/search';
  }

  static forActivityExport() {
    return '/v1.0/control-activities/export';
  }

  static forActivity(activityId) {
    return `/v1.0/control-activities/${activityId}`;
  }

  static forActivityComplete(activityId) {
    return `/v1.0/control-activities/${activityId}/complete`;
  }

  static forActivityClose(activityId) {
    return `/v1.0/control-activities/${activityId}/close`;
  }

  static forActivityReopen(activityId) {
    return `/v1.0/control-activities/${activityId}/reopen`;
  }

  static forActivityResolve(activityId) {
    return `/v1.0/control-activities/${activityId}/resolve`;
  }

  static forActivityExpire(activityId) {
    return `/v1.0/control-activities/${activityId}/expire`;
  }

  static forActivityAssign(activityId) {
    return `/v1.0/control-activities/${activityId}/assign`;
  }

  static forDomains() {
    return '/v1.0/control-domains';
  }

  static forDomainExport() {
    return '/v1.0/control-domains/export';
  }

  static forDomainSearch() {
    return '/v1.0/control-domains/search';
  }

  static forDomain(domainId) {
    return `/v1.0/control-domains/${domainId}`;
  }

  static forSubdomains() {
    return '/v1.0/control-domains/search';
  }

  static forDeployments() {
    return '/v1.0/deployments';
  }

  static forDeploymentSearch() {
    return '/v1.0/deployments/search';
  }

  static forDeployment(deploymentId) {
    return `/v1.0/deployments/${deploymentId}`;
  }

  static forTargets() {
    return '/v1.0/deployment-targets';
  }

  static forTargetSearch() {
    return '/v1.0/deployment-targets/search';
  }

  static forTarget(targetId) {
    return `/v1.0/deployment-targets/${targetId}`;
  }

  static forTargetAssign(targetId) {
    return `/v1.0/deployment-targets/${targetId}/assign`;
  }
  /** Activity Service * */

  static forNode(nodeId) {
    return `/v1.0/nodes/${nodeId}`;
  }

  static forNodeFeed(nodeId) {
    return `/v1.0/nodes/${nodeId}/feed`;
  }

  static forSubscriberActivities(userId) {
    return `/v1.0/nodes/${userId}/subscriber/activities`;
  }

  static forSubscriberActivitiesSearch(userId) {
    return `/v1.0/nodes/${userId}/subscriber/activities/search`;
  }

  static forNodeActivities(nodeId) {
    return `/v1.0/nodes/${nodeId}/feed/activities`;
  }

  static forNodeNotifications(nodeId) {
    return `/v1.0/nodes/${nodeId}/notifications`;
  }

  static forNodeReadReceipt(nodeId) {
    return `/v1.0/nodes/${nodeId}/read`;
  }

  static forNodeDocuments(nodeId) {
    return `/v1.0/nodes/${nodeId}/documents`;
  }

  static forNodeMessages(nodeId) {
    return `/v1.0/nodes/${nodeId}/feed/messages`;
  }

  static forMessage(messageId) {
    return `/v1.0/messages/${messageId}`;
  }

  static forDocuments() {
    return '/v1.0/documents';
  }

  static forDocument(documentId) {
    return `/v1.0/documents/${documentId}`;
  }

  static forDocumentDownload(documentId) {
    return `/v1.0/documents/${documentId}/download`;
  }

  static forDocumentScanSchedulerActivity() {
    return '/v1.0/documents/scheduler-activity';
  }

  static forDocumentScanSchedulerSweepNow() {
    return '/v1.0/documents/scheduler-activity/sweep-now';
  }

  /** Analytics Service * */

  static forAnalyticsRoles() {
    return '/v1.0/analytics-roles';
  }

  static forAnalyticsSettings() {
    return '/v1.0/analytics-settings';
  }

  static forReports() {
    return '/v1.0/reports';
  }

  static forReportSearch() {
    return '/v1.0/reports/search';
  }

  static forReportAssign(reportId) {
    return `/v1.0/reports/${reportId}/assign`;
  }

  static forReport(reportId) {
    return `/v1.0/reports/${reportId}`;
  }

  static forReportSettings(reportId) {
    return `/v1.0/reports/${reportId}/settings`;
  }

  static forReportPublish(reportId) {
    return `/v1.0/reports/${reportId}/publish`;
  }

  static forReportGroups() {
    return '/v1.0/report-groups';
  }

  static forReportGroupSearch() {
    return '/v1.0/report-groups';
  }

  static forReportGroup(groupId) {
    return `/v1.0/report-groups/${groupId}`;
  }

  static forReportRoleUserRiskRollup(reportId) {
    return `/v1.0/reports/${reportId}/data/role-user-risk-rollup`;
  }

  static forReportModelItemRiskRollup(reportId) {
    return `/v1.0/reports/${reportId}/data/model-item-risk-rollup`;
  }

  static forReportFieldItemRiskRollup(reportId) {
    return `/v1.0/reports/${reportId}/data/field-item-risk-rollup`;
  }

  static forReportRegistryComplianceRollup(reportId) {
    return `/v1.0/reports/${reportId}/data/registry-compliance-rollup`;
  }

  static forReportExecutiveRiskOverview(reportId) {
    return `/v1.0/reports/${reportId}/data/executive-risk-overview`;
  }

  static forReportResidualVsTargetRiskTrend(reportId) {
    return `/v1.0/reports/${reportId}/data/residual-vs-target-risk-trend`;
  }

  static forReportRiskScoreCube(reportId) {
    return `/v1.0/reports/${reportId}/data/risk-score-cube`;
  }

  static forReportRiskScoreSankey(reportId) {
    return `/v1.0/reports/${reportId}/data/risk-score-sankey`;
  }

  static forReportUserRiskComparison(reportId) {
    return `/v1.0/reports/${reportId}/data/user-risk-comparison`;
  }

  static forReportControlMaturityByDomain(reportId) {
    return `/v1.0/reports/${reportId}/data/control-maturity-by-domain`;
  }

  static forReportControlComplianceByDomain(reportId) {
    return `/v1.0/reports/${reportId}/data/control-compliance-by-domain`;
  }

  static forReportControlComplianceAndMaturityTrend(reportId) {
    return `/v1.0/reports/${reportId}/data/control-compliance-and-maturity-trend`;
  }

  static forReportControlAttributesOverview(reportId) {
    return `/v1.0/reports/${reportId}/data/control-attributes-overview`;
  }

  static forReportFindingRemediationTracker(reportId) {
    return `/v1.0/reports/${reportId}/data/finding-remediation-tracker`;
  }

  static forReportRiskLeaderboardOverview(reportId) {
    return `/v1.0/reports/${reportId}/data/risk-leaderboard-overview`;
  }

  static forReportDeploymentTargetPortfolio(reportId) {
    return `/v1.0/reports/${reportId}/data/deployment-target-portfolio`;
  }

  static forReportDeploymentTargetComplianceOverview(reportId) {
    return `/v1.0/reports/${reportId}/data/deployment-target-compliance-overview`;
  }

  static forReportComplianceOwnershipByUser(reportId) {
    return `/v1.0/reports/${reportId}/data/compliance-ownership-by-user`;
  }

  static forReportComplianceOwnershipByItem(reportId) {
    return `/v1.0/reports/${reportId}/data/compliance-ownership-by-item`;
  }

  static forDeploymentTargets() {
    return '/v1.0/deployment-targets';
  }

  static forDeploymentTarget(deploymentTargetId) {
    return `/v1.0/deployment-targets/${deploymentTargetId}`;
  }

  static forDeploymentTargetsSearch() {
    return '/v1.0/deployment-targets/search';
  }

  static forActivitySet(activitySetId) {
    return `/v1.0/activity-sets/${activitySetId}`;
  }

  static forDeploymentTargetDefaultAssignments(deploymentTargetId) {
    return `/v1.0/deployment-targets/${deploymentTargetId}/default-assignments`;
  }

  static forDefaultAssignments() {
    return `/v1.0/default-assignments`;
  }

  /* Workflow Service */

  static forNotificationLogs() {
    return '/v1.0/notification-logs';
  }

  static forNotificationLogSearch() {
    return '/v1.0/notification-logs/search';
  }

  static forNotificationLog(logId) {
    return `/v1.0/notification-logs/${logId}`;
  }

  // Audit Service
  static forAudits() {
    return '/v1.0/audits';
  }

  static forAudit(auditId) {
    return `/v1.0/audits/${auditId}`;
  }

  static forAuditSearch() {
    return '/v1.0/audits/search';
  }

  static forAuditSummary(auditId) {
    return `/v1.0/audits/${auditId}/summary`;
  }

  static forAuditSchedule(auditId) {
    return `/v1.0/audits/${auditId}/schedule`;
  }

  static forAuditActivate(auditId) {
    return `/v1.0/audits/${auditId}/activate`;
  }

  static forAuditAssign(auditId) {
    return `/v1.0/audits/${auditId}/assign`;
  }

  static forAuditSubmit(auditId) {
    return `/v1.0/audits/${auditId}/submit`;
  }

  static forAuditClose(auditId) {
    return `/v1.0/audits/${auditId}/close`;
  }

  static forAuditScopes(auditId) {
    return `/v1.0/audits/${auditId}/scopes`;
  }

  static forAuditFindings(auditId) {
    return `/v1.0/audits/${auditId}/findings`;
  }

  static forAuditFindingsSummary(auditId) {
    return `/v1.0/audits/${auditId}/findings/summary`;
  }

  static forAuditFinding(findingId) {
    return `/v1.0/audit-findings/${findingId}`;
  }

  static forAuditScope(auditId, scopeId) {
    return `/v1.0/audits/${auditId}/scopes/${scopeId}`;
  }

  static forAuditScopeActivate(auditId, scopeId) {
    return `/v1.0/audits/${auditId}/scopes/${scopeId}/activate`;
  }

  static forAuditActivities(auditId) {
    return `/v1.0/audits/${auditId}/activities`;
  }

  static forAuditActivitiesSearch(auditId) {
    return `/v1.0/audits/${auditId}/activities/search`;
  }

  static forAuditSummarySearch(auditId) {
    return `/v1.0/audits/${auditId}/summary/search`;
  }

  static forAuditMaturitySearch(auditId) {
    return `/v1.0/audits/${auditId}/maturity-history/search`;
  }

  static forAuditMaturityHistory(auditId, controlId, scopeId) {
    return `/v1.0/audits/${auditId}/maturity-history/${controlId}?scopeId=${scopeId}`;
  }

  static forAuditActivity(auditId, activityId, scopeId) {
    return `/v1.0/audits/${auditId}/activities/${activityId}?scopeId=${scopeId}`;
  }

  // Audit Registries
  static forAuditRegistries() {
    return '/v1.0/audit-registries';
  }

  static forAuditRegistry(registryId) {
    return `/v1.0/audit-registries/${registryId}`;
  }
}
